import React from "react";
var __jsx = React.createElement;
import { memo } from "react";
import classNames from "classnames";
var StepNavigation = /*#__PURE__*/memo(function (_ref) {
  var steps = _ref.steps,
    currentIndex = _ref.currentIndex,
    _ref$maxVisible = _ref.maxVisible,
    maxVisible = _ref$maxVisible === void 0 ? 7 : _ref$maxVisible,
    onStepClick = _ref.onStepClick,
    isStepDisabled = _ref.isStepDisabled,
    isStepComplete = _ref.isStepComplete;
  var totalSteps = steps.length;
  // Determine which steps to show with sliding window
  var getVisibleSteps = function getVisibleSteps() {
    // If all steps fit, show them all
    if (totalSteps <= maxVisible) {
      return steps.map(function (label, index) {
        return {
          label: label,
          index: index,
          isEllipsis: false
        };
      });
    }
    var visible = [];
    // Reserve 2 slots: 1 for ellipsis, 1 for last step
    var windowSize = maxVisible - 2;

    // Calculate window start based on current index
    var windowStart = 0;

    // If current index is beyond the initial window, slide the window
    if (currentIndex >= windowSize) {
      // Slide window to show currentIndex and some steps after it
      windowStart = currentIndex - 1; // Show 1 step before current

      // Make sure we don't go past the point where we can't show enough steps
      var maxWindowStart = totalSteps - windowSize - 1;
      if (windowStart > maxWindowStart) {
        windowStart = maxWindowStart;
      }
    }
    var windowEnd = Math.min(windowStart + windowSize, totalSteps - 1);

    // Add leading ellipsis if window doesn't start at 0
    if (windowStart > 0) {
      visible.push({
        label: "...",
        index: -1,
        isEllipsis: true
      });
    }

    // Add steps in the window
    for (var i = windowStart; i < windowEnd; i++) {
      visible.push({
        label: steps[i],
        index: i,
        isEllipsis: false
      });
    }

    // Add trailing ellipsis if there are hidden steps before the last
    if (windowEnd < totalSteps - 1) {
      visible.push({
        label: "...",
        index: -2,
        isEllipsis: true
      });
    }

    // Always show last step
    visible.push({
      label: steps[totalSteps - 1],
      index: totalSteps - 1,
      isEllipsis: false
    });
    return visible;
  };
  var visibleSteps = getVisibleSteps();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 px-4 py-5 mx-auto"
  }, visibleSteps.map(function (step, idx) {
    if (step.isEllipsis) {
      return /*#__PURE__*/React.createElement("div", {
        key: "ellipsis-".concat(idx),
        className: "w-7 h-7 flex items-center justify-center text-gray-500 text-sm bg-[#19242F] rounded-full"
      }, "...");
    }
    var isActive = step.index === currentIndex;
    var disabled = isActive ? false : Boolean(isStepDisabled === null || isStepDisabled === void 0 ? void 0 : isStepDisabled(step.index));
    var complete = Boolean(isStepComplete === null || isStepComplete === void 0 ? void 0 : isStepComplete(step.index));
    return /*#__PURE__*/React.createElement("button", {
      key: step.index,
      type: "button",
      onClick: function onClick() {
        if (disabled || isActive) return;
        onStepClick === null || onStepClick === void 0 || onStepClick(step.index);
      },
      disabled: disabled,
      className: classNames("w-7 h-7 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-200", {
        // Active state - purple/pink
        "bg-teal-500 text-white": isActive,
        // Completed (filled) state
        "bg-[#19242F] text-white opacity-60 cursor-not-allowed": !isActive && disabled,
        // Incomplete state (clickable)
        "bg-[#38414B] text-white hover:bg-[#233142] cursor-pointer": !isActive && !disabled,
        // Optional complete styling (non-disabled)
        "ring-1 ring-teal-500/40": complete && !isActive && !disabled
      })
    }, step.label);
  }));
});
StepNavigation.displayName = "StepNavigation";
export default StepNavigation;